var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Update",
    transform: "translate(-908 -650)",
    stroke: "#ff7200"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 0,
    height: 0,
    rx: 5,
    transform: "translate(908 650)",
    fill: "#737477"
  }), /*#__PURE__*/React.createElement("g", {
    id: "index",
    transform: "translate(738.232 478.164)",
    fill: "ff7200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M178.68,288.207v10.187a1.883,1.883,0,0,0,1.879,1.879h10.184a1.88,1.88,0,0,0,1.879-1.879v-8.04l-4.07,4.066a1.2,1.2,0,0,1-.476.288l-3.406,1a1.157,1.157,0,0,1-1.139-.292,1.136,1.136,0,0,1-.288-1.151l1-3.387a1.161,1.161,0,0,1,.315-.506l4.046-4.05H180.56a1.883,1.883,0,0,0-1.879,1.879Z",
    transform: "translate(0 -102.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M287.349,392.286a.378.378,0,0,0,.1.38.386.386,0,0,0,.272.111.345.345,0,0,0,.107-.015l3.18-.936-2.719-2.719Z",
    transform: "translate(-103.372 -200.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M315.85,229.641l7.461-7.461,1.2,1.2-7.461,7.461Z",
    transform: "translate(-130.504 -41.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M351.68,265.471l7.461-7.461,1.2,1.2-7.461,7.461Z",
    transform: "translate(-164.593 -75.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M484.778,180.368l-1.4-1.392a1.09,1.09,0,0,0-1.542,0l-1.25,1.25,1.454,1.457s.012.008.015.012.008.008.008.012l1.461,1.457,1.25-1.25a1.1,1.1,0,0,0,0-1.546Z",
    transform: "translate(-287.239 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.b8b7a5ad944bcafddb93ad62b7632e80.svg";
export { ForwardRef as ReactComponent };